export default "__VITE_ASSET__L6HXuj8g__"